import { colorTheme, colorView } from '@uiw/codemirror-extensions-color';

export const color = [colorTheme, colorView(false)];

export default color;
